import React from "react";
import styled from "styled-components";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../../constants/forms";
import { getFieldProps } from "../../../../../utils/form-fields";
import { hexToRGBA } from "../../../../../utils/theme";

import TextInput from "../../../controls/TextInput";
import MaskInput from "../../../controls/MaskInput";

const StyledContainer = styled.div`
  margin-bottom: 24px;
  border: 1px solid ${hexToRGBA('#000000', 0.1)};
  border-radius: 0.25rem;
`;

const StyledRow = styled(Row)`
  padding: 16px;
`;

function CommunicationBlock({ values = {}, onChange, onMouseEnter, onMouseLeave }) {
  return (
    <StyledContainer>
      <div className="inputs-block-title">
        <span>Applicants Contact Information</span>
      </div>
      <StyledRow>
        <Col xs={12} md={6}>
          <MaskInput
            {...getFieldProps(FORM_FIELD_KEYS.customerPhone)}
            label={(
              <>
                Mobile Phone Number&nbsp;
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 0, hide: 0 }}
                  trigger={["hover", "click"]}
                  overlay={(
                    <Tooltip id={`tooltip-${FORM_FIELD_KEYS.ownerSSN}-subhint`} className="subhintTooltipFederal">
                      <span>
                        If any additional information is required to complete your application, we will contact you by phone and/or text message. 
                        Text message updates regarding your order and status will be provided.
                      </span>
                    </Tooltip>
                  )}
                >
                  <a className="ssn-subhint-title">
                    Why is this needed?
                  </a>
                </OverlayTrigger>
              </>
            )}
            value={values[FORM_FIELD_KEYS.customerPhone]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={6}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.customerEmail)}
            label={(
              <>
                Email Address&nbsp;
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 0, hide: 0 }}
                  trigger={["hover", "click"]}
                  overlay={(
                    <Tooltip id={`tooltip-${FORM_FIELD_KEYS.ownerSSN}-subhint`} className="subhintTooltipFederal">
                      <span>
                        We will Email you any important updates regarding your application.
                      </span>
                    </Tooltip>
                  )}
                >
                  <a className="ssn-subhint-title">
                    Why is this needed?
                  </a>
                </OverlayTrigger>
              </>
            )}
            hint={(
              <>
                <strong>Recipient E-mail</strong>
                <br />
                <strong>IMPORTANT:</strong> This is the e-mail where we will send the EIN Number, once processed. Make sure
                it is an e-mail that is checked frequently, and can receive incoming messages.
              </>
            )}
            loading={values.verifying}
            value={values[FORM_FIELD_KEYS.customerEmail]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
      </StyledRow>
    </StyledContainer>
  );
}

export default CommunicationBlock;
